const metrics = [
    {
        name: "collaboration-time",
        value: 7.52,
        oldValue: 5.09,
    },
    {
        name: "collaboration-network",
        value: 6.23,
        oldValue: 3.78,
    },
];

const overall = {
    value: 7.29,
    oldValue: 6.69,
};

const timeseries = [
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-11 00:00:00",
        value: 3.7,
    },
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-12 00:00:00",
        value: 3.7,
    },
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-13 00:00:00",
        value: 3.7,
    },
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-14 00:00:00",
        value: 3.7,
    },
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-15 00:00:00",
        value: 3.7,
    },
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-16 00:00:00",
        value: 4.228,
    },
    {
        subcategory: "collaboration_network",
        name: "gns",
        datetime: "2024-04-17 00:00:00",
        value: 4.228,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-15 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-16 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "grr",
        datetime: "2024-04-17 00:00:00",
        value: 0,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-11 00:00:00",
        value: 5.1,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-12 00:00:00",
        value: 3.65,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-13 00:00:00",
        value: 3.65,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-14 00:00:00",
        value: 3.65,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-15 00:00:00",
        value: 3.6,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-16 00:00:00",
        value: 4.347,
    },
    {
        subcategory: "collaboration_network",
        name: "sns",
        datetime: "2024-04-17 00:00:00",
        value: 6.307,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-11 00:00:00",
        value: 6.5,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-12 00:00:00",
        value: 4.45,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-13 00:00:00",
        value: 4.45,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-14 00:00:00",
        value: 4.45,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-15 00:00:00",
        value: 3.933,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-16 00:00:00",
        value: 4.19,
    },
    {
        subcategory: "collaboration_network",
        name: "ssmr",
        datetime: "2024-04-17 00:00:00",
        value: 4.366,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-12 00:00:00",
        value: 6.6,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-13 00:00:00",
        value: 6.6,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-14 00:00:00",
        value: 6.6,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-15 00:00:00",
        value: 6.6,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-16 00:00:00",
        value: 9.242,
    },
    {
        subcategory: "collaboration_network",
        name: "stn",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-11 00:00:00",
        value: 4.2,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-12 00:00:00",
        value: 4.2,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-13 00:00:00",
        value: 2.8,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-14 00:00:00",
        value: 2.1,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-15 00:00:00",
        value: 2.52,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-16 00:00:00",
        value: 3.36,
    },
    {
        subcategory: "collaboration_time",
        name: "got",
        datetime: "2024-04-17 00:00:00",
        value: 4.56,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-11 00:00:00",
        value: 6.4,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-12 00:00:00",
        value: 8.2,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-13 00:00:00",
        value: 5.466,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-14 00:00:00",
        value: 4.1,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-15 00:00:00",
        value: 4.88,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-16 00:00:00",
        value: 6.88,
    },
    {
        subcategory: "collaboration_time",
        name: "sot",
        datetime: "2024-04-17 00:00:00",
        value: 8.88,
    },
];
const getCollaborationMiniIndexes = () => {
    return {
        metrics,
        overall,
        timeseries,
    };
};

export default getCollaborationMiniIndexes;
